import { render } from "./ssqfu.vue?vue&type=template&id=037b22ed&scoped=true"
import script from "./ssqfu.vue?vue&type=script&lang=js"
export * from "./ssqfu.vue?vue&type=script&lang=js"

import "./ssqfu.vue?vue&type=style&index=0&id=037b22ed&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037b22ed"]])

export default __exports__